"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var ListingOpenAction = /** @class */ (function (_super) {
    __extends(ListingOpenAction, _super);
    function ListingOpenAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function (e) {
            e.stopPropagation();
            _this.props.onOpen(_this.props.listing);
        };
        return _this;
    }
    ListingOpenAction.prototype.render = function () {
        if (this.props.onOpen) {
            return (React.createElement(Button_1.IconButton, { onClick: this._onClick, title: this.props.listing.title ? "Open " + this.props.listing.title + " in new window" : "Open in new window", iconProps: { iconName: "OpenInNewWindow" } }));
        }
        return null;
    };
    return ListingOpenAction;
}(React.Component));
exports.ListingOpenAction = ListingOpenAction;
var ListingLoadAction = /** @class */ (function (_super) {
    __extends(ListingLoadAction, _super);
    function ListingLoadAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function (e) {
            e.stopPropagation();
            _this.props.onLoad(_this.props.listing);
        };
        return _this;
    }
    ListingLoadAction.prototype.render = function () {
        if (this.props.onLoad) {
            return (React.createElement(Button_1.IconButton, { onClick: this._onClick, title: this.props.listing ? "Load " + this.props.listing.title + " in current window" : "Load in current window", iconProps: { iconName: "OpenFile" } }));
        }
        return null;
    };
    return ListingLoadAction;
}(React.Component));
exports.ListingLoadAction = ListingLoadAction;
